import { SvgIcon } from "@sveabank/cc-common";

type Props = {
	children?: React.ReactNode;
};

const Header = ({ children }: Props) => (
	<div className="page-container">
		<header className="border-foreground-divider bg-background-primary font-default mx-auto flex w-full items-center justify-between border-b border-solid p-4 px-0">
			<SvgIcon imageSrc="LOGO" height={32} className="text-interactive-secondary" />
			{children}
		</header>
	</div>
);

export default Header;
